export const CREDENCIAL_ACCOUNTS_ROUTE_PATHS = {
  credencialAccounts: '/treasury/credencial-accounts',
};

/** Account ID allowed to perform outgoing transfers in prod. No restriction in non-prod. */
export const OUTGOING_TRANSFER_PROD_ACCOUNT_ID = 2806011;

/** Default destination CVU pre-filled in the outgoing transfer form. */
export const OUTGOING_TRANSFER_DEFAULT_CVU = '4130010131004213640114';

export const CREDENCIAL_ACCOUNTS_API_PATHS = {
  accounts: '/v1/api/platform/treasury-management/credencial/accounts',
  addFunds: '/v1/api/platform/treasury-management/credencial/accounts/{accountId}/add-funds',
  removeFunds: '/v1/api/platform/treasury-management/credencial/accounts/{accountId}/remove-funds',
  resolveCvu: '/v1/api/platform/transfer-platform/transfers/cvu/resolve',
  outgoingTransfer: '/v1/api/platform/transfer-platform/transfers/cvu/outgoing',
  transferRequests: '/v1/api/platform/treasury-management/credencial/accounts/{accountId}/transfer-requests',
};
